"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActorInitQuery = void 0;
const ActorInitQueryBase_1 = require("./ActorInitQueryBase");
/* istanbul ignore next */
if (typeof process === 'undefined') {
    // Polyfills process.nextTick for readable-stream
    globalThis.process = require('process/');
}
class ActorInitQuery extends ActorInitQueryBase_1.ActorInitQueryBase {
}
exports.ActorInitQuery = ActorInitQuery;
//# sourceMappingURL=ActorInitQuery-browser.js.map